import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextInput from "./TextInput";
const AddressInput = ({ label, placeholder, fieldName, value, onChange, required, highlighted, }) => {
    const style = highlighted ? { borderColor: "#FF877B" } : {};
    return (_jsxs("div", { children: [_jsxs("label", { className: "my-4 block w-full", htmlFor: fieldName, children: [label, " ", required && _jsx("span", { className: "text-wfRed-600", children: "*" })] }), _jsx(TextInput, { id: fieldName, style: style, placeholder: placeholder, value: value, onChange: onChange, required: required, className: "p-2 w-full text-lg font-semibold" })] }));
};
export default AddressInput;
